module.exports = __webpack_public_path__ + "./images/958f1e78ccd64aa18b5ad61694e21198.webp";